import { createRoot } from "react-dom/client";
import { App } from "web_myplann/Infrastructure/App";

const container = document.getElementById("rootmydock2");
if (!container) {
	throw new Error("Root container #rootmydock2 not found");
}

createRoot(container).render(<App />);
